import { getAuthToken } from '@/auth/authCredentials';

export function authHeader() {
  const token = getAuthToken();
  if (token) {
    return `Bearer ${token}`;
  }
  return null;
}
